import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import Vue from 'vue'

@Module({
  namespaced: true
})
export default class OutlookStore extends VuexModule {
  config: KwixeoOutlook.Configuration|null = null

  // CLEAR STORE STATE
  @Action
  clearStore (): void {
    this.context.commit('setConfig', null)
  }
  @Mutation
  setConfig (config: KwixeoOutlook.Configuration|null): void {
    this.config = config
  }

  @Action
  async loadConfig (force = false): Promise<void> {
    if (this.config === null || force) {
      const response = await Vue.prototype.$kwOutlook.axios.get('/outlook/configuration')
      await this.context.commit('setConfig', response.data)
    }
  }

  @Action
  updateConfig (config: KwixeoOutlook.Configuration): void {
    this.context.commit('setConfig', config)
  }
}
